import { cilFile } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CButton } from '@coreui/react'
import BaseListing from 'src/BaseListings'
import BankTransactionPDF from 'src/PDF/BankTransactionPDF'
import BankReceiptVoucherPDF from 'src/PDF/BankReceiptVoucherPDF'
import ChequePrintPDF from 'src/PDF/ChequePrintPDF'
import JvPaymentBpvPDF from 'src/PDF/JvPaymentBpvPDF'
import JvPaymentVoucherBundlePDF from 'src/PDF/JvPaymentVoucherBundlePDF'
import JvPaymentVoucherPDF from 'src/PDF/JvPaymentVoucherPDF'
import VoucherPDF from 'src/PDF/VoucherPDF'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { wtGetDateOnly, wtGetDateTimeFormat } from 'src/helpers/commons/moment'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtFormatRoundedValue } from 'src/helpers/commons/utils'
import getColumnSearchProps, { getDropdownSearchProps } from 'src/widgets/Filters/ColumnSearch'

// Source Types
export const SOURCE_TYPE_DEFAULT = 1
export const SOURCE_TYPE_BANK_TRANSACTIONS = 2
export const SOURCE_TYPE_SALE_ORDER_ADVANCE_RECEIPT = 3
export const SOURCE_TYPE_SALE_ORDER_INVOICE = 4;
export const SOURCE_TYPE_SALARY_EXPENSE = 5
export const SOURCE_TYPE_SALARY_PAYMENT = 6
export const SOURCE_TYPE_ADDVANCE_RECEIPT = 7
export const SOURCE_TYPE_JV_PAYMENT = 8
export const SOURCE_TYPE_TAX_PAYMENTS = 9



export const SOURCE_TYPE_NAMES = {
  1: 'Default',
  2: 'Bank Transactions',
  3: 'Sale Order Advance Receipt',
  4: 'Sale Order Invoice',
  5: 'Salary Expense',
  6: 'Salary Payment',
  7: 'Advance Receipt',
  8: 'JV Payment',
  9: 'Tax Payments',
}

export const SOURCE_TYPE_DROPDOWN_OPTIONS = [
  {
    value: SOURCE_TYPE_DEFAULT,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_DEFAULT],
  },
  {
    value: SOURCE_TYPE_BANK_TRANSACTIONS,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_BANK_TRANSACTIONS],
  },
  {
    value: SOURCE_TYPE_SALE_ORDER_ADVANCE_RECEIPT,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_SALE_ORDER_ADVANCE_RECEIPT],
  },
  {
    value: SOURCE_TYPE_SALE_ORDER_INVOICE,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_SALE_ORDER_INVOICE],
  },
  {
    value: SOURCE_TYPE_SALARY_EXPENSE,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_SALARY_EXPENSE],
  },
  {
    value: SOURCE_TYPE_SALARY_PAYMENT,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_SALARY_PAYMENT],
  },
  {
    value: SOURCE_TYPE_ADDVANCE_RECEIPT,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_ADDVANCE_RECEIPT],
  },
  {
    value: SOURCE_TYPE_JV_PAYMENT,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_JV_PAYMENT],
  },
  {
    value: SOURCE_TYPE_TAX_PAYMENTS,
    label: SOURCE_TYPE_NAMES[SOURCE_TYPE_TAX_PAYMENTS],
  },
]


// paid through
export const PAID_THROUGH_CHEQUE = 1
export const PAID_THROUGH_ONLINE = 2

export const PAID_THROUGH_NAMES = {
  1: 'Cheque',
  2: 'Online',
}

export const PAID_THROUGH_DROPDOWN_OPTIONS = [
  { value: PAID_THROUGH_CHEQUE, label: PAID_THROUGH_NAMES[PAID_THROUGH_CHEQUE] },
  { value: PAID_THROUGH_ONLINE, label: PAID_THROUGH_NAMES[PAID_THROUGH_ONLINE] },
]

// Voucher Types
export const VOUCHER_TYPE_BANK_PAYMENT_VOUCHER = 1
export const VOUCHER_TYPE_BANK_RECEIPT_VOUCHER = 2
export const VOUCHER_TYPE_CASH_PAYMENT_VOUCHER = 3
export const VOUCHER_TYPE_CASH_RECEIPT_VOUCHER = 4
export const VOUCHER_TYPE_JOURNAL_VOUCHER = 5
export const VOUCHER_TYPE_INTER_BANK_TRANSFER_VOUCHER = 6
export const VOUCHER_TYPE_CASH_DEPOSIT_VOUCHER = 7
export const VOUCHER_TYPE_CASH_WITHDRAWAL_VOUCHER = 8

export const VOUCHER_TYPE_NAMES = {
  1: 'Bank Payment Voucher',
  2: 'Bank Receipt Voucher',
  3: 'Cash Payment Voucher',
  4: 'Cash Receipt Voucher',
  5: 'Journal Voucher',
  6: 'Inter Bank Transfer Voucher',
  7: 'Cash Deposit Voucher',
  8: 'Cash Withdrawal Voucher',
}

export const VOUCHER_TYPE_SHORT_NAMES = {
  1: 'BPV',
  2: 'BRV',
  3: 'CPV',
  4: 'CRV',
  5: 'JV',
  6: 'IBTV',
  7: 'CDV',
  8: 'CWV',
}

export const VOUCHER_TYPE_DROPDOWN_OPTIONS = [
  {
    value: VOUCHER_TYPE_BANK_PAYMENT_VOUCHER,
    label: VOUCHER_TYPE_NAMES[VOUCHER_TYPE_BANK_PAYMENT_VOUCHER],
  },
  {
    value: VOUCHER_TYPE_BANK_RECEIPT_VOUCHER,
    label: VOUCHER_TYPE_NAMES[VOUCHER_TYPE_BANK_RECEIPT_VOUCHER],
  },
  {
    value: VOUCHER_TYPE_CASH_PAYMENT_VOUCHER,
    label: VOUCHER_TYPE_NAMES[VOUCHER_TYPE_CASH_PAYMENT_VOUCHER],
  },
  {
    value: VOUCHER_TYPE_CASH_RECEIPT_VOUCHER,
    label: VOUCHER_TYPE_NAMES[VOUCHER_TYPE_CASH_RECEIPT_VOUCHER],
  },
  { value: VOUCHER_TYPE_JOURNAL_VOUCHER, label: VOUCHER_TYPE_NAMES[VOUCHER_TYPE_JOURNAL_VOUCHER] },
]

// voucher status
export const STATUS_JUST_PLACED = 1
export const STATUS_APPROVED = 2
export const STATUS_POSTED = 3
export const STATUS_CANCELLED = 4

export const STATUS_NAME = {
  1: 'Just Placed',
  2: 'Audited',
  3: 'Approved',
  4: 'Cancelled',
}

export const VOUCHER_STATUS_DROPDOWN_OPTIONS = [
  { value: STATUS_JUST_PLACED, label: STATUS_NAME[STATUS_JUST_PLACED] },
  { value: STATUS_APPROVED, label: STATUS_NAME[STATUS_APPROVED] },
  { value: STATUS_POSTED, label: STATUS_NAME[STATUS_POSTED] },
  { value: STATUS_CANCELLED, label: STATUS_NAME[STATUS_CANCELLED] },
]

const generateVoucherByEndpoint = (endpoint, id, PrintCheque = false) => {
  wtApiCall(
    `${endpoint}/${id}`,
    {},
    'get',
    async (response) => {
      const { data } = response
      const { voucher } = data
      console.log(voucher)
      if (PrintCheque === false) {
        if (
          voucher.type === VOUCHER_TYPE_BANK_RECEIPT_VOUCHER &&
          voucher.source_type !== SOURCE_TYPE_BANK_TRANSACTIONS
        ) {
          BankReceiptVoucherPDF(data)
        } else if (voucher.source_type === SOURCE_TYPE_DEFAULT) {
          VoucherPDF(data)
        } else if (voucher.source_type === SOURCE_TYPE_BANK_TRANSACTIONS) {
          BankTransactionPDF(data)
        } else if (
          voucher.source_type === SOURCE_TYPE_JV_PAYMENT &&
          voucher.type === VOUCHER_TYPE_JOURNAL_VOUCHER
        ) {
          JvPaymentVoucherPDF(data)
        } else if (
          voucher.source_type === SOURCE_TYPE_JV_PAYMENT &&
          voucher.type === VOUCHER_TYPE_BANK_PAYMENT_VOUCHER
        ) {
          try {
            const paymentResponse = await wtApiCallPromise(`jv_payment_details/${voucher.source_id}`)
            const requestVoucherId = paymentResponse?.data?.payment_request?.voucher_id

            if (Number(requestVoucherId) > 0) {
              await printJvPaymentBundle(requestVoucherId, [voucher.id], 'bpv')
              return
            }
          } catch (error) {}

          JvPaymentBpvPDF(data)
        }
        else {
          VoucherPDF(data)
        }
      }
      else {
        const beneficiary_name = voucher.party ? voucher.party.name : voucher.reference
        const cheque_date = voucher.cheque_date
        const amount = voucher.hash_amount
        const bank = voucher.entry_types.bank
        const beneficiary_name_x = bank.beneficiary_name_x
        const beneficiary_name_y = bank.beneficiary_name_y
        const cheque_date_x = bank.cheque_date_x
        const cheque_date_y = bank.cheque_date_y
        const amount_in_word_x = bank.amount_in_word_x
        const amount_in_word_y = bank.amount_in_word_y
        const amount_x = bank.amount_x
        const amount_y = bank.amount_y


        const chequeData = {
          chequeDate: cheque_date,
          beneficiaryName: beneficiary_name,
          amount: amount,
          beneficiary_name_x: beneficiary_name_x,
          beneficiary_name_y: beneficiary_name_y,
          cheque_date_x: cheque_date_x,
          cheque_date_y: cheque_date_y,
          amount_in_word_x: amount_in_word_x,
          amount_in_word_y: amount_in_word_y,
          amount_x: amount_x,
          amount_y: amount_y
        }

        ChequePrintPDF(chequeData)
      }
    },
    (error) => {
      lzNotifyErrorMessageFromResult(error)
    },
  )
}

export const generateVoucher = (id, PrintCheque = false) =>
  generateVoucherByEndpoint('vouchers', id, PrintCheque)

export const generateDeletedVoucher = (id, PrintCheque = false) =>
  generateVoucherByEndpoint('deleted_voucher_view', id, PrintCheque)

const wtApiCallPromise = (endpoint, params = {}, method = 'get') =>
  new Promise((resolve, reject) => {
    wtApiCall(endpoint, params, method, resolve, reject)
  })

const buildJvPaymentBundleData = (voucherResponses) =>
  voucherResponses.map((response) => {
    const pdfData = response.data
    const voucherType = pdfData?.voucher?.type
    const voucherDetails = Array.isArray(pdfData?.voucher_detail) ? pdfData.voucher_detail : []
    const uniqueEmployees = [
      ...new Set(
        voucherDetails
          .map(
            (item) =>
              item?.employee?.full_name ||
              item?.employee?.name ||
              `${item?.employee?.first_name || ''} ${item?.employee?.last_name || ''}`.trim(),
          )
          .filter(Boolean),
      ),
    ]
    const uniqueParties = [
      ...new Set(
        voucherDetails.map((item) => item?.party?.party_name || item?.party?.name).filter(Boolean),
      ),
    ]

    if (voucherType === VOUCHER_TYPE_JOURNAL_VOUCHER) {
      return {
        ...pdfData,
        pdf_meta: {
          title: 'Journal Voucher',
          typeLabel: 'Journal Voucher',
          referenceLabel: 'Reference:',
          showEmployeeColumn: uniqueEmployees.length > 1,
          showPartyColumn: uniqueParties.length > 1,
          showSelectionSummary: true,
          showSingleSelectionSummaryOnly: true,
          headerLayout: 'jv_payment',
        },
      }
    }

    return {
      ...pdfData,
      pdf_meta: {
        title: 'Bank Payment Voucher',
        typeLabel: 'Bank Payment Voucher',
        referenceLabel: 'Pay To:',
        showEmployeeColumn: uniqueEmployees.length > 1,
        showPartyColumn: uniqueParties.length > 1,
        showSelectionSummary: true,
        showSingleSelectionSummaryOnly: true,
        headerLayout: 'jv_payment',
        sideBySideBankSelectionDetails: true,
      },
    }
  })

const printJvPaymentBundle = async (requestVoucherId, bpvVoucherIds = [], primaryVoucherType = 'jv') => {
  const filteredBpvIds = bpvVoucherIds.filter((id) => Number(id) > 0)
  const voucherIds =
    primaryVoucherType === 'bpv'
      ? [...filteredBpvIds, requestVoucherId]
      : [requestVoucherId, ...filteredBpvIds]
  const voucherResponses = await Promise.all(
    voucherIds.map((id) => wtApiCallPromise(`vouchers/${id}`)),
  )

  JvPaymentVoucherBundlePDF(buildJvPaymentBundleData(voucherResponses))
}

export const generateJvPaymentRequestVoucher = async (requestId) => {
  try {
    const requestResponse = await wtApiCallPromise(`jv_payment_requests/${requestId}`)
    const requestRecord = requestResponse.data

    if (!requestRecord?.voucher_id) {
      throw { message: 'JV voucher not found for this request.' }
    }

    const bpvIds = [
      ...new Set(
        (requestRecord.payment_details || [])
          .map((payment) => payment.bpv_voucher_id)
          .filter((id) => Number(id) > 0),
      ),
    ]

    if (bpvIds.length === 0) {
      generateVoucher(requestRecord.voucher_id)
      return
    }

    await printJvPaymentBundle(requestRecord.voucher_id, bpvIds, 'jv')
  } catch (error) {
    lzNotifyErrorMessageFromResult(error)
  }
}

export const generateJvPaymentRequestBpvVoucher = async (requestId, bpvVoucherId) => {
  try {
    const requestResponse = await wtApiCallPromise(`jv_payment_requests/${requestId}`)
    const requestRecord = requestResponse.data

    if (!requestRecord?.voucher_id) {
      throw { message: 'JV voucher not found for this request.' }
    }

    if (!(Number(bpvVoucherId) > 0)) {
      throw { message: 'BPV voucher not found for this request.' }
    }

    await printJvPaymentBundle(requestRecord.voucher_id, [bpvVoucherId], 'bpv')
  } catch (error) {
    lzNotifyErrorMessageFromResult(error)
  }
}

const Base = new BaseListing('vouchers')
// data Table columns
export const VOUCHER_COLUMNS = [
  {
    key: 'branch_id',
    title: 'Branch',
    render: (record) => record.branch.name,
    sorter: true,
    sortDirections: ['ascend', 'descend'],
  },

  {
    key: 'voucher_no',
    title: 'Voucher No',
    dataIndex: 'voucher_no',
    render: (text, record) => (
      <span style={{ color: 'green' }}>
        {`${record.type_short_name}-${record.company_voucher_no}-${record.voucher_no}`}
      </span>
    ),
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'monthly_voucher_no',
    title: 'Monthly Voucher No',
    dataIndex: 'monthly_voucher_no',
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'type',
    title: 'Type',
    dataIndex: 'type',
    render: (text, record) => record.type_name,
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'type',
    title: 'Source Type',
    dataIndex: 'source_type',
    render: (text, record) => SOURCE_TYPE_NAMES[record.source_type],
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'hash_amount',
    title: () => 'Hash Amount',
    dataIndex: 'hash_amount',
    sorter: true,
    render: (text) => <span style={{ color: 'blue' }}>{wtFormatRoundedValue(text, '')}</span>,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'cheque_no',
    title: () => 'Cheque No',
    dataIndex: 'cheque_no',
    render: (text, record) => (record.cheque_no ? record.cheque_no : '-'),
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },

  {
    key: 'reference',
    title: 'Reference',
    dataIndex: 'reference',
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },

  {
    key: 'voucher_date',
    title: 'Voucher Date',
    dataIndex: 'voucher_date',
    render: (text) => wtGetDateOnly(text),
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },

  {
    key: 'created_at',
    title: 'Created At',
    dataIndex: 'created_at',
    render: (text) => wtGetDateTimeFormat(text),
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (text, record) => record.status_name,
    sorter: true,
    sortDirections: ['ascend', 'descend'],

  },

  {
    key: 'action',
    title: 'Action',
    render: (record) => {
      return (
        <>

          {Base.hasRights('Print Vouchers') && (
            <CButton
              className="text-white btn-sm"
              shape="rounded-pill"
              color="info"
              onClick={() => generateVoucher(record.id)}
            >
              <CIcon icon={cilFile} />
            </CButton>
          )}

        </>
      )
    },
  },
]
